import { LoanStatus } from '@nemuru-eng/js-api-client';

import { FunnelStageStep } from '../types/funnelStageStep';

export const getLoanStatusListDefinitions = (loanLenderBorrowerContract?: { isSent: boolean; isSigned: boolean }) => ({
  [LoanStatus.STATUS_INITIAL]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_APPLICATION_STARTED',
    SECTION_T_ID: FunnelStageStep.STARTED,
    colorPaletteName: 'default',
    colorType: 'dark',
  },
  [LoanStatus.STATUS_ANALYSING]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_ANALYSING',
    SECTION_T_ID: FunnelStageStep.REQUESTED,
    colorPaletteName: 'info',
    colorType: 'main',
  },
  [LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED]: {
    DESCRIPTION_T_ID:
      loanLenderBorrowerContract?.isSent === true || !loanLenderBorrowerContract
        ? 'STATUS_DESC_LENDER_HAS_BEEN_SELECTED'
        : 'STATUS_DESC_PENDING_CONTRACT_SENDING',
    SECTION_T_ID: FunnelStageStep.APPROVED,
    colorPaletteName: 'success',
    colorType: 'dark',
  },
  [LoanStatus.STATUS_CONTRACT_SIGNED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_CONTRACT_SIGNED',
    SECTION_T_ID: FunnelStageStep.APPROVED,
    colorPaletteName: 'success',
    colorType: 'dark',
  },
  [LoanStatus.STATUS_DOCS_APPROVED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_PAYMENT_PENDING',
    SECTION_T_ID: FunnelStageStep.CONFIRMED,
    colorPaletteName: 'success',
    colorType: 'main',
  },
  [LoanStatus.STATUS_ACTIVE_TRIAL]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_ACTIVE',
    SECTION_T_ID: FunnelStageStep.PAID,
    colorPaletteName: 'success',
    colorType: 'main',
  },
  [LoanStatus.STATUS_ACTIVE]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_ACTIVE',
    SECTION_T_ID: FunnelStageStep.PAID,
    colorPaletteName: 'success',
    colorType: 'main',
  },
  [LoanStatus.STATUS_DENIED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_DENIED',
    SECTION_T_ID: FunnelStageStep.DENIED,
    colorPaletteName: 'error',
    colorType: 'main',
  },
  [LoanStatus.STATUS_DESISTED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_DESISTED',
    SECTION_T_ID: FunnelStageStep.DESISTED,
    colorPaletteName: 'minor',
    colorType: 'main',
  },
  [LoanStatus.STATUS_EXPIRED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_EXPIRED',
    SECTION_T_ID: FunnelStageStep.EXPIRED,
    colorPaletteName: 'minor',
    colorType: 'main',
  },
  [LoanStatus.STATUS_CANCELLED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_CANCELLED',
    SECTION_T_ID: FunnelStageStep.CANCELLED,
    colorPaletteName: 'minor',
    colorType: 'main',
  },
  [LoanStatus.STATUS_CANCELLED_TEST]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_CANCELLED',
    SECTION_T_ID: FunnelStageStep.CANCELLED,
    colorPaletteName: 'minor',
    colorType: 'main',
  },
});
